
<template>
    <div class="attr-flyline-wrapper">
        <Row class="attr-flyline-item">
            <i-col span="8">飞线类型</i-col>
            <i-col span="16">
                <RadioGroup v-model="value" @on-change="update">
                    <Radio v-for="it in types" :key="it.value" :label="it.value">
                        {{it.value}}
                    </Radio>
                </RadioGroup>
            </i-col>
        </Row>
        <Row class="attr-flyline-item">
            <i-col span="8">底图颜色</i-col>
            <i-col span="16">
                <ColorPicker v-model="mapBackground" />
            </i-col>
        </Row>
        <Row class="attr-flyline-item">
            <i-col span="8">分割线颜色</i-col>
            <i-col span="16">
                <ColorPicker v-model="mapBackground" />
            </i-col>
        </Row>
    </div>
</template>
<script>
import './flyline-attr.less';
export default {
    name: 'FlyLineAttr',
    props: {
        options:{
            type: Object,
            default(){
                return {
                    value: 'plane',
                    mapBackground: '#063F7A',
                    borderColor: '#FF0000'
                }
            }
        }
    },
    data(){
        return {
            //飞线类型
            value: 'plane',
            mapBackground:'#063F7A',
            borderColor: '',
            types: [
                {
                    label: '飞线',
                    value: 'plane'
                },
                {
                    label: '光束',
                    value: 'light'
                }
            ]
        }
    },
    watch: {
        options: {
            handler(){
                const propsOptions = this.options;
                for(let i in propsOptions){
                    let item = propsOptions[i];
                    if(this[i]){
                        this[i] = item;
                    }
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        update(){
            const {value} = this;
            this.$emit('flyline-attr',{
                type: value
            })
        }
    }
}
</script>